Vendd.Scripts.load(function () {
    'use strict';

    var $notifications = $('.js-header-notification');

    if ($notifications.length < 1)
        return;

     $notifications.each(function () { 
        var $wrapper = $(this), index = $wrapper.data('index');

        $('.js-close-header-notification', $wrapper).on('click', function () {
            $wrapper.hide();

            Cookies.set("noHeaderNotification-" + index, true, { samesite: 'Lax' });
        });

        var flag = Cookies.get('noHeaderNotification-' + index);  
    
        if ( flag === null || typeof flag === 'undefined' ) {
            $wrapper.show();
        } 

    });
});
